import { render, staticRenderFns } from "./telegramLoginButton.vue?vue&type=template&id=09fc421b&scoped=true&"
import script from "./telegramLoginButton.vue?vue&type=script&lang=js&"
export * from "./telegramLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./telegramLoginButton.vue?vue&type=style&index=0&id=09fc421b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fc421b",
  null
  
)

export default component.exports